import { render } from "./GamesNew.vue?vue&type=template&id=60fd26eb&scoped=true&ts=true&style=width%3A%20100%25%3B%20height%3A%20100%25"
import script from "./GamesNew.vue?vue&type=script&lang=ts"
export * from "./GamesNew.vue?vue&type=script&lang=ts"

import "./GamesNew.vue?vue&type=style&index=0&id=60fd26eb&scoped=true&lang=css"
import "./GamesNew.vue?vue&type=style&index=1&id=60fd26eb&lang=css"

import exportComponent from "/data/landun/workspace/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60fd26eb"]])

export default __exports__